/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PropertyFromJSON(json) {
    return PropertyFromJSONTyped(json, false);
}
export function PropertyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'propertyName': !exists(json, 'propertyName') ? undefined : json['propertyName'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'gps': !exists(json, 'gps') ? undefined : json['gps'],
        'reqHelpName': !exists(json, 'reqHelpName') ? undefined : json['reqHelpName'],
        'reqHelpPhone': !exists(json, 'reqHelpPhone') ? undefined : json['reqHelpPhone'],
        'reqHelpEmail': !exists(json, 'reqHelpEmail') ? undefined : json['reqHelpEmail'],
        'reqMessage': !exists(json, 'reqMessage') ? undefined : json['reqMessage'],
        'reqMessageExpire': !exists(json, 'reqMessageExpire') ? undefined : (json['reqMessageExpire'] === null ? null : new Date(json['reqMessageExpire'])),
        'location1Label': !exists(json, 'location1Label') ? undefined : json['location1Label'],
        'location2Label': !exists(json, 'location2Label') ? undefined : json['location2Label'],
        'floorLabel': !exists(json, 'floorLabel') ? undefined : json['floorLabel'],
        'propertyActiveFlag': !exists(json, 'propertyActiveFlag') ? undefined : json['propertyActiveFlag'],
        'newOrdersToREQ': !exists(json, 'newOrdersToREQ') ? undefined : json['newOrdersToREQ'],
        'propertyTimeZoneCode': !exists(json, 'propertyTimeZoneCode') ? undefined : json['propertyTimeZoneCode'],
        'ordererFieldLabel2': !exists(json, 'ordererFieldLabel2') ? undefined : json['ordererFieldLabel2'],
    };
}
export function PropertyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'propertyId': value.propertyId,
        'propertyName': value.propertyName,
        'address': value.address,
        'city': value.city,
        'state': value.state,
        'zip': value.zip,
        'gps': value.gps,
        'reqHelpName': value.reqHelpName,
        'reqHelpPhone': value.reqHelpPhone,
        'reqHelpEmail': value.reqHelpEmail,
        'reqMessage': value.reqMessage,
        'reqMessageExpire': value.reqMessageExpire === undefined ? undefined : (value.reqMessageExpire === null ? null : value.reqMessageExpire.toISOString()),
        'location1Label': value.location1Label,
        'location2Label': value.location2Label,
        'floorLabel': value.floorLabel,
        'propertyActiveFlag': value.propertyActiveFlag,
        'newOrdersToREQ': value.newOrdersToREQ,
        'propertyTimeZoneCode': value.propertyTimeZoneCode,
        'ordererFieldLabel2': value.ordererFieldLabel2,
    };
}
